import { useState, useEffect, useCallback } from 'react';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { ServiceDeskContext } from '@atlassian/jira-router-resources-service-desk-portal-settings-context/src/services/index.tsx';

type UseClassicSettingsProviderType = {
	projectKey: string;
};

export const classicSettingsProviderUrl = ({ projectKey }: UseClassicSettingsProviderType) =>
	`/rest/servicedesk/1/servicedesk-data/${projectKey}`;

export const classicSettingsPermissionsProviderUrl = ({
	projectKey,
}: UseClassicSettingsProviderType) =>
	`/rest/servicedesk/1/servicedesk/${projectKey}/settings/requestsecurity`;

export const useClassicSettingsProvider = ({ projectKey }: UseClassicSettingsProviderType) => {
	const [error, setError] = useState<unknown>(undefined);
	const [data, setData] = useState<ServiceDeskContext | undefined>(undefined);

	const fetchData = useCallback(async () => {
		try {
			const [response, permissionsData] = await Promise.all([
				fetchJson(classicSettingsProviderUrl({ projectKey })),
				fetchJson(classicSettingsPermissionsProviderUrl({ projectKey })),
			]);
			const { serviceDeskOpenAccess } = permissionsData;
			setData({
				...response,
				serviceDeskOpenAccess,
			});
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			setError(e);
		}
	}, [projectKey]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	return {
		error,
		data,
	};
};
